import { Controller } from "stimulus"

export default class extends Controller {
    static targets = [
        'modal',
        'patientId',
        'name',
        'birthday',
        'corporateCode',
        'userList',
        'userTableBody',
        'pagination',
        'paginationList',
        'selectedUserId',
        'currentUserId',
        'currentUserName',
        'currentUserKana',
        'currentUserBirthday'
    ]

    static values = {
        currentPage: { type: Number, default: 1 },
        perPage: { type: Number, default: 20 },
        totalPages: { type: Number, default: 1 }
    }

    connect() {
        console.log('Change user controller connected')
    }

    openModal(event) {
        event.preventDefault()
        // ボタンからreservation-idを取得
        const reservationId = event.currentTarget.dataset.reservationId
        this.reservationId = reservationId

        this.modalTarget.classList.add('is-active')
        // 現在の受診者情報を表示
        this.loadCurrentUserInfo()
    }

    close() {
        this.modalTarget.classList.remove('is-active')
        this.resetForm()
    }

    resetForm() {
        this.patientIdTarget.value = ''
        this.nameTarget.value = ''
        this.birthdayTarget.value = ''
        this.corporateCodeTarget.selectedIndex = 0
        this.userTableBodyTarget.innerHTML = '<tr><td colspan="8" class="has-text-centered">検索してください</td></tr>'
        this.currentPageValue = 1
        this.selectedUserIdTarget.value = ''
    }

    // 現在の受診者情報を取得
    loadCurrentUserInfo() {
        fetch(`/admin/health_check_reservations/${this.reservationId}/current_user`, {
            headers: {
                'Accept': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
                'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
            }
        })
            .then(response => response.json())
            .then(data => {
                this.displayCurrentUserInfo(data.user)
            })
            .catch(error => console.error('Error:', error))
    }

    // 現在の受診者情報を表示
    displayCurrentUserInfo(user) {
        this.currentUserIdTarget.textContent = user.patients_id || ''
        this.currentUserNameTarget.textContent = `${user.last_name} ${user.first_name}`
        this.currentUserKanaTarget.textContent = `${user.last_name_kana} ${user.first_name_kana}`
        this.currentUserBirthdayTarget.textContent = user.birthday ? new Date(user.birthday).toLocaleDateString('ja-JP') : ''
    }

    search(event) {
        event.preventDefault()
        this.currentPageValue = 1
        this.fetchUsers()
    }

    fetchUsers() {
        const params = new URLSearchParams({
            page: this.currentPageValue,
            patients_id: this.patientIdTarget.value,
            name: this.nameTarget.value,
            birthday: this.birthdayTarget.value,
            corporate_code: this.corporateCodeTarget.value
        })

        return fetch(`/admin/health_check_users/search_for_link?${params.toString()}`, {
            headers: {
                'Accept': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
                'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
            }
        })
            .then(response => response.json())
            .then(data => {
                this.renderUsers(data.users)
                this.totalPagesValue = data.total_pages
                this.renderPagination()
                return data;
            })
            .catch(error => console.error('Error:', error))
    }

    renderUsers(users) {
        this.userTableBodyTarget.innerHTML = ''

        if (users.length === 0) {
            const tr = document.createElement('tr')
            tr.innerHTML = '<td colspan="8" class="has-text-centered">該当するユーザーがいません</td>'
            this.userTableBodyTarget.appendChild(tr)
            return
        }

        users.forEach(user => {
            const tr = document.createElement('tr')
            tr.innerHTML = `
                <td>
                    <div class="control">
                        <input type="radio" name="selected_user" value="${user.id}" 
                               data-action="click->admin--health-check-users--change-user#selectUser">
                    </div>
                </td>
                <td>${user.patients_id || ''}</td>
                <td>${user.last_name} ${user.first_name}</td>
                <td>${user.last_name_kana} ${user.first_name_kana}</td>
                <td>${user.gender_name}</td>
                <td>${user.birthday ? new Date(user.birthday).toLocaleDateString('ja-JP') : ''}</td>
                <td>${user.corporate_name || ''}</td>
                <td>${user.employee_number || ''}</td>
            `
            this.userTableBodyTarget.appendChild(tr)
        })
    }

    renderPagination() {
        this.paginationListTarget.innerHTML = ''

        const prevButton = this.paginationTarget.querySelector('.pagination-previous')
        const nextButton = this.paginationTarget.querySelector('.pagination-next')

        prevButton.disabled = this.currentPageValue <= 1
        nextButton.disabled = this.currentPageValue >= this.totalPagesValue

        for (let i = 1; i <= this.totalPagesValue; i++) {
            const li = document.createElement('li')
            const a = document.createElement('a')

            a.classList.add('pagination-link')
            if (i === this.currentPageValue) {
                a.classList.add('is-current')
            }

            a.setAttribute('aria-label', `Page ${i}`)
            a.dataset.page = i
            a.textContent = i
            a.dataset.action = 'click->admin--health-check-users--change-user#goToPage'

            li.appendChild(a)
            this.paginationListTarget.appendChild(li)
        }
    }

    previousPage(event) {
        event.preventDefault()
        if (this.currentPageValue > 1) {
            this.currentPageValue--
            this.fetchUsers()
        }
    }

    nextPage(event) {
        event.preventDefault()
        if (this.currentPageValue < this.totalPagesValue) {
            this.currentPageValue++
            this.fetchUsers()
        }
    }

    goToPage(event) {
        event.preventDefault()
        this.currentPageValue = parseInt(event.currentTarget.dataset.page)
        this.fetchUsers()
    }

    selectUser(event) {
        const userId = event.target.value
        this.selectedUserIdTarget.value = userId
    }

    changeUser() {
        const selectedUserId = this.selectedUserIdTarget.value

        if (!selectedUserId) {
            alert('健診受診者を選択してください')
            return
        }

        if (!confirm('この健診受診者に変更しますか？')) {
            return
        }

        fetch(`/admin/health_check_reservations/${this.reservationId}/change_user`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
                'Accept': 'application/json'
            },
            body: JSON.stringify({
                health_check_user_id: selectedUserId
            })
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(data => {
                if (data.success) {
                    alert("健診受診者の変更が完了しました")
                    // URLからreturn_toパラメータを取得
                    const urlParams = new URLSearchParams(window.location.search)
                    const returnTo = urlParams.get('return_to')
                    window.location.href = data.redirect_url + (returnTo ? `&return_to=${returnTo}` : '')
                } else {
                    alert(data.message || "変更に失敗しました")
                }
            })
            .catch(error => {
                console.error('Error:', error);
                alert("エラーが発生しました: " + error.message);
            });
    }

    selectClear(event) {
        event.preventDefault();
        this.birthdayTarget.value = '';
    }
}